import { PageGeometry, PdfRect, ScreenRect } from './types';

export function screenRectToPdfRect(rect: ScreenRect, geom: PageGeometry): PdfRect {
  const c1 = geom.toPdfPoint({ x: rect.x, y: rect.y });
  const c2 = geom.toPdfPoint({ x: rect.x + rect.width, y: rect.y + rect.height });
  const x = Math.min(c1.x, c2.x);
  const y = Math.min(c1.y, c2.y);
  return { x, y, width: Math.abs(c2.x - c1.x), height: Math.abs(c2.y - c1.y) };
}

export function pdfRectToScreenRect(rect: PdfRect, geom: PageGeometry): ScreenRect {
  const c1 = geom.toScreenPoint({ x: rect.x, y: rect.y });
  const c2 = geom.toScreenPoint({ x: rect.x + rect.width, y: rect.y + rect.height });
  const x = Math.min(c1.x, c2.x);
  const y = Math.min(c1.y, c2.y);
  return { x, y, width: Math.abs(c2.x - c1.x), height: Math.abs(c2.y - c1.y) };
}

export function clampPdfRectToPage(rect: PdfRect, geom: PageGeometry): PdfRect {
  const x = Math.max(0, Math.min(rect.x, geom.pageWidthPdf));
  const y = Math.max(0, Math.min(rect.y, geom.pageHeightPdf));
  const width = Math.max(0, Math.min(rect.width, geom.pageWidthPdf - x));
  const height = Math.max(0, Math.min(rect.height, geom.pageHeightPdf - y));
  return { x, y, width, height };
}
